import { TextField } from "@mui/material";

const UseInfoMain = ({
  isEdit,
  userInfo,
  setUserInfo,
  validateStatus,
  setValidateStatus
}) => {
  const nameHandler = (value, key) => {
    const trimmed = value.trim();
    let val = { valid: true, message: "" };

    if (trimmed.length === 0 && key !== "middleName") {
      val = { valid: false, message: "1文字以上入力してください" };
    }

    if (trimmed.length > 10) {
      val = { valid: false, message: "各10文字以内で入力してください" };
    }

    if (trimmed.length > 0) {
      const allowedRegex =
        /^[\u3040-\u30FF\u4E00-\u9FFF\uFF10-\uFF19a-zA-Z\s\-'.]+$/;
      if (!allowedRegex.test(trimmed)) {
        val = { valid: false, message: "日本語またはローマ字で入力してください" };
      }
    }

    setValidateStatus((prev) => ({
      ...prev,
      [key]: val
    }));
    setUserInfo((prev) => ({ ...prev, [key]: trimmed }));
  };

  const nameEnHandler = (value, key) => {
    const trimmed = value.toUpperCase().trim();
    let val = { valid: true, message: "" };

    const isOptional = key === "middleNameEn";

    if (!isOptional && trimmed.length === 0) {
      val = { valid: false, message: "1文字以上入力してください" };
    }

    if (trimmed.length > 0) {
      if (trimmed.length > 10) {
        val = { valid: false, message: "各10文字以内で入力してください" };
      }

      const alphaOnlyRegex = /^[a-zA-Z\s\-'.]+$/;
      if (!alphaOnlyRegex.test(trimmed)) {
        val = { valid: false, message: "ローマ字（半角英字）のみで入力してください" };
      }
    }

    setValidateStatus((prev) => ({
      ...prev,
      [key]: val
    }));
    setUserInfo((prev) => ({ ...prev, [key]: trimmed }));
  };

  return (
    <>
      <dt>名前{isEdit && <span>※</span>}</dt>
      <dd>
        {isEdit ? (
          <div style={{ display: "grid", gap: "8px" }}>
            <label>
              <span className="label">姓</span>
              <TextField
                value={userInfo.familyName}
                onChange={(e) => nameHandler(e.target.value, "familyName")}
                error={!validateStatus.familyName?.valid}
                helperText={validateStatus.familyName?.message}
                InputProps={{
                  sx: { "& input": { padding: "8px 16px" } }
                }}
                sx={{ width: "100%" }}
              />
            </label>

            <label>
              <span className="label">ミドルネーム</span>
              <small>(任意)</small>
              <TextField
                value={userInfo.middleName}
                onChange={(e) => nameHandler(e.target.value, "middleName")}
                error={!validateStatus.middleName?.valid}
                helperText={validateStatus.middleName?.message}
                InputProps={{
                  sx: { "& input": { padding: "8px 16px" } }
                }}
                sx={{ width: "100%" }}
              />
            </label>

            <label>
              <span className="label">名</span>
              <TextField
                value={userInfo.firstName}
                onChange={(e) => nameHandler(e.target.value, "firstName")}
                error={!validateStatus.firstName?.valid}
                helperText={validateStatus.firstName?.message}
                InputProps={{
                  sx: { "& input": { padding: "8px 16px" } }
                }}
                sx={{ width: "100%" }}
              />
            </label>
          </div>
        ) : (
          <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            {userInfo.familyName}{" "}
            {userInfo.middleName ? userInfo.middleName + " " : ""}
            {userInfo.firstName}
          </span>
        )}
      </dd>

      <dt>ローマ字{isEdit && <span>※</span>}</dt>
      <dd>
        {isEdit ? (
          <div style={{ display: "grid", gap: "8px" }}>
            <label>
              <span className="label">First Name</span>
              <TextField
                value={userInfo.firstNameEn}
                onChange={(e) => nameEnHandler(e.target.value, "firstNameEn")}
                error={!validateStatus.firstNameEn?.valid}
                helperText={validateStatus.firstNameEn?.message}
                InputProps={{
                  sx: { "& input": { padding: "8px 16px" } }
                }}
                sx={{ width: "100%" }}
              />
            </label>

            <label>
              <span className="label">Middle Name</span>
              <small>(任意)</small>
              <TextField
                value={userInfo.middleNameEn}
                onChange={(e) => nameEnHandler(e.target.value, "middleNameEn")}
                error={!validateStatus.middleNameEn?.valid}
                helperText={validateStatus.middleNameEn?.message}
                InputProps={{
                  sx: { "& input": { padding: "8px 16px" } }
                }}
                sx={{ width: "100%" }}
              />
            </label>

            <label>
              <span className="label">Family Name</span>
              <TextField
                value={userInfo.familyNameEn}
                onChange={(e) => nameEnHandler(e.target.value, "familyNameEn")}
                error={!validateStatus.familyNameEn?.valid}
                helperText={validateStatus.familyNameEn?.message}
                InputProps={{
                  sx: { "& input": { padding: "8px 16px" } }
                }}
                sx={{ width: "100%" }}
              />
            </label>
          </div>
        ) : (
          <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            {userInfo.firstNameEn}{" "}
            {userInfo.middleNameEn ? userInfo.middleNameEn + " " : ""}
            {userInfo.familyNameEn}
          </span>
        )}
      </dd>
    </>
  );
};

export default UseInfoMain;
